'use strict';

var React = require('react');

module.exports = function toArray(children) {
  var ret = [];
  React.Children.forEach(children, function each(c) {
    ret.push(c);
  });
  return ret;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-util/lib/Children/toArray.js
 ** module id = 402
 ** module chunks = 0
 **/